import { render, staticRenderFns } from "./FormAddressValidationModalAddress.vue?vue&type=template&id=585d7617&scoped=true"
import script from "./FormAddressValidationModalAddress.vue?vue&type=script&lang=js"
export * from "./FormAddressValidationModalAddress.vue?vue&type=script&lang=js"
import style0 from "./FormAddressValidationModalAddress.vue?vue&type=style&index=0&id=585d7617&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585d7617",
  null
  
)

export default component.exports